import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IStepValidation, WizardStep } from '../../../dialogs/wizard/WizardStep';
import {
  DataSourceParams,
  EFilterType,
  ITableColumn,
  ITableDataSource,
  ITableFIlterGroup,
} from '../../../store/models/table.model';
import { IAccount } from '../../../store/models/account.model';
import { SelectRoleWizardStepComponent } from '../select-role-wizard-step/select-role-wizard-step.component';
import { ApiDataSource } from '../../../datasources/api.datasrouce';
import { HttpClient } from '@angular/common/http';
import { SelectionChange } from '@angular/cdk/collections';
import { environment } from '../../../../environments/environment';
import { UserType } from '../../../store/models/user.model';

@Component({
  selector: 'app-select-users-wizard-step',
  templateUrl: './select-users-wizard-step.component.html',
  styleUrls: ['./select-users-wizard-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectUsersWizardStepComponent implements OnInit, WizardStep {
  static NAME = 'select-users-wizard-step';
  wizardData: { [key: string]: any; };
  preselectedUsers: number[] = [];
  preselected: { account_id: number }[] = [];

  tableFilterGroups: ITableFIlterGroup[] = [
    {
      filters: [
        {
          type: EFilterType.SEARCH,
          label: 'Search',
          items: [
            {
              id: 'search',
              label: 'Search',
            },
          ],
        },
      ],
    },
  ];

  tableColumns: ITableColumn<IAccount>[] = [
    {
      id: 'first_name',
      title: 'Name',
      renderer: row => {
        return `${row.first_name}${row.last_name ? (' ' + row.last_name) : ''}`;
      },
    },
    {
      id: 'email',
      title: 'Email',
    },
    {
      id: 'account_id',
      title: 'ID',
      renderer: row => `#${row.account_id}`,
    },
  ];

  tableDataSource: ApiDataSource<IAccount>;

  tableDatasourceParams: DataSourceParams;

  componentReady = false;

  selectedUsers: number[] = [];

  /** Franchisee closer reports are scoped to exactly one franchisee, so the picker becomes single-select. */
  singleSelection = false;

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  provideData() {
    return {
      users: this.selectedUsers,
    };
  }

  async validate(): Promise<IStepValidation> {
    if (this.singleSelection && this.selectedUsers.length > 1) {
      return {
        success: false,
        errors: [
          'Please, select only one franchisee',
        ],
      };
    }

    if (this.selectedUsers.length) {
      return {
        success: true,
      };
    }

    return {
      success: false,
      errors: [
        'Please, select at least one user',
      ],
    };
  }

  ngOnInit(): void {
    const role = this.wizardData[SelectRoleWizardStepComponent.NAME].role;
    this.singleSelection = role === UserType.FRANCHISE;

    if (this.wizardData[SelectUsersWizardStepComponent.NAME].users) {
      this.preselectedUsers = this.wizardData[SelectUsersWizardStepComponent.NAME].users;
    }
    if (this.singleSelection && this.preselectedUsers.length > 1) {
      this.preselectedUsers = this.preselectedUsers.slice(0, 1);
    }

    if (this.preselectedUsers.length) {
      this.preselected = this.preselectedUsers.map(u => ({ account_id: u }));
    }
    if (role) {
      this.tableDataSource = new ApiDataSource(this.http, environment.apiUrl + '/v1/users');
      this.tableDatasourceParams = {
        page: 1,
        pageSize: 10,
        sortAttr: 'account_id',
        sortDir: 'desc',
        filters: {
          user_type: role,
        },
      };
      this.componentReady = true;
    }
  }

  onRowSelection($event: SelectionChange<any>) {
    this.selectedUsers = $event.source.selected.map(a => a.account_id);
  }
}
